import { type URLParameter } from './types';

export class URLBuilder {
	url: string;
	params: Record<string, URLParameter>;

	constructor(url: string) {
		this.url = url;
		this.params = {};
	}

	withQueryParam(key: string, value: URLParameter) {
		this.params[key] = value;

		return this;
	}

	build() {
		const filteredParams = Object.entries(this.params).filter(
			([, value]) => value !== undefined && value !== null && value !== '',
		);

		const queryInstance = new URLSearchParams(filteredParams as any);
		const queryParams = queryInstance.toString();

		if (queryParams) {
			return `${this.url}?${queryParams}`;
		}

		return this.url;
	}
}
